import React, { useEffect, useState } from "react";
import { Box, Typography, styled, Button, Grid, Input } from "@mui/material";
import {
  useApplyCoupon,
  useGetWallet,
  useGiftCoupon,
  usePaymentGateway,
} from "../../Hooks/wallet.hooks";
import * as Styles from "../../Common/Styles.js";
import { toast } from "react-toastify";
import QRcode from "../../Assets/Homeimg/QRcode.png";
import { useGetUserProfile } from "../../Hooks/ProfileHooks";
import { Link, useNavigate } from "react-router-dom";
import cookie from "js-cookie";
const QRCodeStaticScanner = () => {
  const navigate = useNavigate();
  const [couponCode, setCouponCode] = useState("");
  const [giftCouponCode, setGiftCouponCode] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const { mutate: applyCoupon } = useApplyCoupon();
  const { mutate: giftCoupon } = useGiftCoupon();
  const { mutate: paymentGateWay } = usePaymentGateway();
  const {
    data: walletData,
    isLoading: walletLoading,
    error: walletError,
    refetch: walletDataRefetch,
  } = useGetWallet();

  const {
    data: profileData,
    isLoading: profileLoading,
    error: profileError,
    refetch: profileDataRefetch,
  } = useGetUserProfile();
  const isLoggedIn = profileData !== undefined;
  const isNonStudent =
    isLoggedIn && profileData?.data?.data?.profession !== "student";
  const getToken = () => {
    return cookie.get("Bearer");
  };
  const handleApplyCoupon = () => {
    if (couponCode) {
      applyCoupon(
        { couponCode },
        {
          onSuccess: () => {
            toast.success("Coupon applied successfully");
            setCouponCode("");
            walletDataRefetch();
          },
          onError: () => {
            toast.error("Failed to apply coupon");
          },
        }
      );
    }
  };

  const handleGiftCoupon = () => {
    if (giftCouponCode) {
      giftCoupon(
        { code: giftCouponCode },
        {
          onSuccess: () => {
            toast.success("Coupon applied successfully");
            setGiftCouponCode("");
            walletDataRefetch();
          },
          onError: () => {
            toast.error("Failed to apply gift coupon");
          },
        }
      );
    }
  };

  const handlePaymentGateway = (amount) => {
    console.log("amount", amount);
    paymentGateWay(
      { amount: amount || paymentAmount },
      {
        onSuccess: (res) => {
          walletDataRefetch();
          window.location.href = `${res?.data?.redirect_url}`;
        },
        onError: () => {
          toast.error("Payment gateway error occurred");
        },
      }
    );
  };

  const [tab, setTab] = useState(0);
  return (
    <>
      <Grid
        container
        rowSpacing={2}
        sx={{
          width: "90%",
          mx: "auto",
          mt: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
          <Box
            sx={{
              ...Styles.categoriesBox,
              background: tab === 0 ? "#091A32" : "rgba(247, 249, 251, 1)",
              color: tab === 0 ? "rgba(255, 255, 255, 1)" : "rgba(62, 50, 50, 1)",
            }}
            onClick={() => {
              setTab(0);
              // setPaymentAmount("");
            }}
          >
            General Plan
          </Box>
          <Box
            sx={{
              ...Styles.categoriesBox,
              background: tab === 1 ? "#091A32" : "rgba(247, 249, 251, 1)",
              color: tab === 1 ? "rgba(255, 255, 255, 1)" : "rgba(62, 50, 50, 1)",
              opacity: isNonStudent ? 0.5 : 1,
              pointerEvents: isLoggedIn && isNonStudent ? "none" : "auto",
            }}
            onClick={() => {
              setTab(1);
              // setPaymentAmount("2500");
            }}
          >
            <Typography>Student Plan</Typography>
          </Box>
          <Box
            sx={{
              ...Styles.categoriesBox,
              background: tab === 2 ? "#091A32" : "rgba(247, 249, 251, 1)",
              color: tab === 2 ? "rgba(255, 255, 255, 1)" : "rgba(62, 50, 50, 1)",
            }}
            onClick={() => {
              setTab(2);
              // setPaymentAmount("");
            }}
          >
            <Typography>Top Up Plan</Typography>
          </Box>
          <Box
            sx={{
              ...Styles.categoriesBox,
              background: tab === 3 ? "#091A32" : "rgba(247, 249, 251, 1)",
              color: tab === 3 ? "rgba(255, 255, 255, 1)" : "rgba(62, 50, 50, 1)",
            }}
            onClick={() => setTab(3)}
          >
            <Typography>Gift Voucher</Typography>
          </Box>
        </Box>

        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          <Box sx={mainBox}>
            {/* General Plan */}
            {tab === 0 && (
              <>
                <Typography sx={Styles.paymentHaderText}>
                  General Plan
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", mt: 2, flexWrap: { sm: "wrap", xs: "wrap" } }}>
                  <Box sx={paymentBox}>
                    <Box sx={insideBoxPayment}>Monthly Plan</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 650</Typography>
                      <Typography sx={paymentSubText}>per month</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>90</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>28 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("650")}>Pay now</Box>
                    ) : null}
                  </Box>
                  <Box sx={paymentBox}>
                    <Box sx={insideBoxPayment}>Yearly Plan</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 5999</Typography>
                      <Typography sx={paymentSubText}>per annum</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>1700</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>365 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("5999")}>Pay now</Box>
                    ) : null}
                  </Box>
                </Box>
              </>
            )}

            {/* Student Plan */}
            {tab === 1 && (
              <>
                <Typography sx={Styles.paymentHaderText}>
                  Student Plan
                </Typography>
                {isNonStudent && (
                  <Typography sx={{ color: "red", fontSize: "14px", mt: 1, mb: 2, fontFamily: "Manrope" }}>
                    Note: Student plan is only available for users with student status in their profile.
                  </Typography>
                )}
                <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", mt: 2, flexWrap: { sm: "wrap", xs: "wrap" } }}>
                  <Box sx={paymentBox}>
                    <Box sx={insideBoxPayment}>Yearly Plan</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 2500</Typography>
                      <Typography sx={paymentSubText}>per annum</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>370</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>365 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("2500")}>Pay now</Box>
                    ) : null}
                  </Box>
                </Box>
              </>
            )}

            {/* Top Up Plan */}
            {tab === 2 && (
              <>
                <Typography sx={Styles.paymentHaderText}>
                  Top Up Plan
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", mt: 2, flexWrap: "wrap" }}>
                  <Box sx={{ ...paymentBox, width: { xl: "200px", lg: "200px", md: "230px", sm: "auto", xs: "auto" } }}>
                    <Box sx={insideBoxPayment}>Plan 1</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 350</Typography>
                      <Typography sx={paymentSubText}>one time</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>470</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>28 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("350")}>Pay now</Box>
                    ) : null}
                  </Box>
                  <Box sx={paymentBox}>
                    <Box sx={insideBoxPayment}>Plan 2</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 1000</Typography>
                      <Typography sx={paymentSubText}>one time</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>1650</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>365 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("1000")}>Pay now</Box>
                    ) : null}
                  </Box>
                  <Box sx={paymentBox}>
                    <Box sx={insideBoxPayment}>Plan 3</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 2000</Typography>
                      <Typography sx={paymentSubText}>one time</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>4000</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>365 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("2000")}>Pay now</Box>
                    ) : null}
                  </Box>
                  <Box sx={paymentBox}>
                    <Box sx={insideBoxPayment}>Plan 4</Box>
                    <Box>
                      <Typography sx={paymentText}>Rs. 6000</Typography>
                      <Typography sx={paymentSubText}>one time</Typography>
                    </Box>
                    <Box sx={creditstext}>Credits : <span style={{ fontWeight: "bold", color: "#000" }}>15000</span></Box>
                    <Box sx={creditstext}>validate : <span style={{ fontWeight: "bold", color: "#000" }}>365 days</span></Box>
                    <Box component={"hr"} sx={{ borderBottom: "0.3px solid rgba(217, 217, 217, 1)", width: "90%" }} />
                    {getToken() ? (
                      <Box sx={BtnPayNow} onClick={() => handlePaymentGateway("6000")}>Pay now</Box>
                    ) : null}
                  </Box>
                </Box>
              </>
            )}

            {/* Gift Voucher */}
            {tab === 3 && (
              <>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                  <Typography sx={Styles.paymentHaderText}>
                    Gift Card
                  </Typography>
                  <Box
                    component={"hr"}
                    sx={{
                      borderBottom: "1px solid rgba(209, 209, 209, 1)",
                      width: "100%",
                    }}
                  />
                  <Typography mt={1} sx={paymentSubText}>
                    Please apply gift voucher here to get amazing credits.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 3,
                    gap: 1,
                    flexDirection: { xs: "column", sm: "row" },
                    width: "100%",
                    maxWidth: "500px",
                    mx: "auto",
                  }}
                >
                  <Input
                    id="gift-coupon-input"
                    variant="outlined"
                    disableUnderline
                    placeholder="Enter Gift Coupon Code"
                    value={giftCouponCode}
                    onChange={(e) => setGiftCouponCode(e.target.value)}
                    sx={{
                      ...Styles.InputFieldDes,
                      border: "1px solid rgba(209, 209, 209, 1)",
                      borderRadius: "5px",
                      flex: 1,
                      p: 1,
                    }}
                    inputProps={{
                      style: {
                        color: "#797979",
                        fontSize: "14px",
                        fontFamily: "Manrope",
                        padding: "4px",
                        paddingLeft: "10px",
                      },
                    }}
                  />
                  {getToken() ? (
                    <Button
                      onClick={handleGiftCoupon}
                      sx={{
                        ...BtnPayNow,
                        width: { xs: "100%", sm: "auto" },
                        px: 3,
                        py: 1,
                        ml: { xs: 0, sm: 1 },
                        mt: { xs: 2, sm: 0 },
                      }}
                    >
                      Apply
                    </Button>
                  ) : null}
                </Box>
              </>
            )}

            {/* Common footer note */}
            <Typography
              sx={{
                ...Styles.blogmainText,
                textAlign: "center",
                width: "100%",
                mt: 4,
                fontFamily: "Manrope",
                fontSize: "14px",
              }}
            >
              <span style={{ fontWeight: "bold" }}>Note</span>: Payments are
              non-refundable as per our Payment & Refund Policy as per Section
              29.{" "}
              <Link
                style={{ cursor: "pointer", color: "#091A32" }}
                onClick={() => {
                  navigate("/termsandcondition#specific-section");
                }}
              >
                Terms & Conditions
              </Link>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default QRCodeStaticScanner;

const paymentText = {
  fontFamily: "Manrope",
  fontSize: { xl: "34px", lg: "34px", md: "34px", sm: "12px", xs: "12px" },
  fontWeight: 700,
  textAlign: "center",
  color: "rgba(37, 36, 48, 1)",
};
const paymentBox = { display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", border: "1px solid rgba(217, 217, 217, 1)", borderRadius: "10px", p: 2, width: { xl: "230px", lg: "230px", md: "230px", sm: "auto", xs: "auto" } }
const paymentSubText = {
  fontFamily: "Manrope",
  fontSize: { xl: "14px", lg: "14px", md: "14px", sm: "12px", xs: "12px" },
  fontWeight: 400,
  textAlign: "center",
  color: "rgba(37, 36, 48, 1)",
};
const insideBoxPayment = { color: "rgba(19, 19, 19, 1)", fontFamily: "Manrope", background: "rgba(19, 19, 19, 0.1)", textAlign: "center", p: 0.8, borderRadius: "10px", width: "170px" }
const imgqr = {
  height: "auto",
  maxWidth: {
    xl: "150px",
    lg: "150px",
    md: "150px",
    sm: "120px",
    xs: "120px",
  },
};

const mainBox = {
  border: "1px solid rgba(230, 233, 245, 1)",
  borderRadius: "10px",
  width: {
    xl: "1100px",
    lg: "900px",
    md: "500px",
    sm: "auto",
    xs: "auto",
  },
  height: "auto",
  p: 3,
};

const btnWidth = {
  display: "flex",

  justifyContent: "center",
  gap: "10px",
  width: {
    xl: "80%",
    lg: "80%",
    md: "80%",
    sm: "95%",
    xs: "95%",
  },
  mx: "auto",
  textAlign: "center",
};

const sizeAdj = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: {
    xl: "row",
    lg: "row",
    md: "row",
    sm: "column",
    xs: "column",
  },
  gap: { xl: "100px", lg: "100px", md: "100px", sm: "30px", xs: "30px" },
  mt: 2,
};

const creditstext = {
  fontSize: { xl: "18px", lg: "18px", md: "18px", sm: "12px", xs: "12px" },
  fontFamily: "Manrope",
  fontWeight: 500,
  textAlign: "center",
  color: "rgba(19, 19, 19, 1)",
}

const BtnPayNow = { background: "rgba(19, 19, 19, 1)", color: "rgba(255, 255, 255, 1)", p: 1, borderRadius: "5px", width: "190px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }